<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="700px" :close-on-click-modal="false">
        <div class="dialogContent" v-loading="loading">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">
                <el-form-item label="订单类型" prop="orderType">
                    <el-select v-model="form.orderType" placeholder="请选择" @change="selectSecondList">
                        <el-option label="打印" value="PRINT"> </el-option>
                        <el-option label="商城" value="SHOP"> </el-option>
                        <el-option label="设计" value="DESIGN"> </el-option>
                        <el-option label="模型" value="MODEL"> </el-option>
                        <el-option label="服务" value="SERVICE"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="子类" v-if="showType" prop="secondTypeUuid">
                    <el-select v-model="form.secondTypeUuid" filterable
                               @change="copyOptionLabel"
                                placeholder="请选择">
                        <el-option
                            v-for="item in secondTypeList"
                            :key="item.uuid"
                            :label="item.name"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="佣金比例(%)"  prop="commissionPer">
                    <el-input-number v-model="form.commissionPer" placeholder="请输入佣金比例"
                                     :min="0" :max="100" style="width:220px"></el-input-number>
                </el-form-item>
                <el-form-item label="折扣比例(%)" prop="discountPer">
                    <el-input-number v-model="form.discountPer" placeholder="请输入折扣比例"
                                     :min="0" :max="100" style="width:220px"></el-input-number>
                </el-form-item>
                <el-form-item class="submitButtonClass">
                    <el-button @click="submit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>

</template>
<script>
    import {
        findCommission,
        saveCommission,
        designerLevelListByPage,
        getShopCategoryList, synCommission
    } from "../../utils/interface";

    export default {
        name: "commissionDialog",
        data() {
            return {
                title:'',
                dialogVisible: false,
                showType:false,
                loading: false,
                dialogFormVisible: false,
                form: {
                    // orderType: 'PRINT',
                    orderType: '',
                    secondTypeUuid: '',
                    commissionPer: '',
                    discountPer: '',
                    secondType:''
                },
                rules: {
                    orderType: [
                        {required: true, message: '请选择订单类型', trigger: 'blur'}
                    ],
                    commissionPer: [
                        {required: true, message: '请输入佣金比例', trigger: 'blur'}
                    ],
                    discountPer: [
                        {required: true, message: '请输入折扣比例', trigger: 'blur'}
                    ],
                    secondTypeUuid: [
                        {required: true, message: '请选择子类型', trigger: 'blur'}
                    ],
                },
                secondTypeList: [],
            }
        },
        methods: {
            init(type, uuid) {
                this.loading = true;
                this.dialogVisible = true;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
                this.reset();
                if (type === "add") {
                    this.title = "新增佣金设置";
                    this.loading = false;
                } else {
                    this.title = "修改佣金设置";
                    findCommission(uuid).then((res) => {
                        this.secondValue(res.data.orderType);
                        // this.form = res.data;
                        let that = this;
                        setTimeout(function () {
                            that.form = res.data;
                            that.loading = false;
                        },400)
                    });
                }

            },
            submit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        /*saveCommission(this.form).then((res) => {
                            this.$message.success(res.message);
                            this.dialogVisible = false;
                            this.$parent.getList();
                        });*/
                        let params = {
                            orderType:this.form.orderType,
                            uuid: this.form.uuid,
                            secondTypeUuid: this.form.secondTypeUuid
                        };
                        synCommission(params).then((res) => {
                            if (res.success == true) {
                                saveCommission(this.form).then((res) => {
                                    this.$message.success(res.message);
                                    this.dialogVisible = false;
                                    this.$parent.getList();
                                });
                            } else {
                                this.$message.warning("同类型同子类佣金设置不能重复");
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 初始话重置表单
            reset() {
                this.form = {
                    orderType: '',
                    secondTypeUuid: '',
                    commissionPer: '',
                    discountPer: '',
                    secondType:'',
                };
                this.secondTypeList=[];
                this.showType=false;
            },
            selectSecondList(val){
                this.form.secondTypeUuid='';
                this.form.secondType='';
                this.secondTypeList = [];
                this.secondValue(val);
            },
            secondValue(val){
                if(val=="SHOP"){
                    this.showType = true;
                    let params = {
                        parentUuid:"",
                        grade:"1",
                        type:'PLATFORM',
                        current:1,
                        pageSize:100,
                    }
                    getShopCategoryList(params).then((res)=>{
                        this.secondTypeList = res.list;
                    });
                }else if(val=="DESIGN"){
                    let params = {
                        current: 1,
                        pageSize: 100
                    };
                    designerLevelListByPage(params).then((res) => {
                        this.secondTypeList = res.list;
                    });
                    this.showType = true;
                }else if(val=="MODEL"){
                    this.showType = true;
                    let params = {
                        current: 1,
                        pageSize: 100,
                        type: 'MODEL'
                    };
                    designerLevelListByPage(params).then((res) => {
                        this.secondTypeList = res.list;
                    });
                }else {
                    this.showType = false;
                }
            },
            copyOptionLabel(value){
                let obj = {};
                obj = this.secondTypeList.find((item)=>{
                    return item.uuid === value;
                });
                this.form.secondType = obj.name;
            },
        }
    }
</script>

<style scoped lang="less">
    .typeItems{
        /deep/.el-form-item__content{
            margin-left: 0px!important;
        }
    }
    .dialogContent {
        padding: 0 5%;

        /deep/ .el-upload-list--picture-card .el-upload-list__item {
            width: 590px;
            height: 300px;
        }

        /deep/ .el-upload--picture-card {
            width: 590px;
            height: 300px;
            line-height: 300px;
        }

        /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
            width: 590px;
            height: 300px;
        }

        .titleTop {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 26px;
            margin-left: 48px;
        }

        .thumbnailClass {
            width: 150px;
            height: 150px;

            .avatar {
                width: 150px;
                height: 150px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 140px;
                font-size: 50px;
            }
        }

        .thumbnailClass2 {
            width: 222px;
            height: 125px;
            margin-left: 16px;
            margin-bottom: 5px;
        }

        .thumbnailClass20 {
            .avatar2 {
                width: 222px;
                height: 125px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 125px;
                font-size: 50px;
                margin-left: 16px;

                p {
                    margin: 0;
                    font-size: 16px;
                }
            }
        }

        .endPeriodClass {
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }

        .submitButtonClass {
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
                text-align: center;

                button {
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }

        .modelHeightRangeClass {
            display: flex;
            margin-bottom: 25px;

            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }

    .successImgsUrl {
        cursor: pointer;
        color: #409EFF;
    }

    .print_screen_boxP {
        display: flex;
        flex-wrap: wrap;
        p {
            cursor: pointer;
            margin-bottom: 10px;
            margin-right: 0px;
            padding: 3px 14px;
            font-size: 14px;
        }

        .screen_text {
            color: #157efb;
            background: #157efb;
            border-radius: 5px;
            margin-bottom: 10px;
            color: #fff;
            padding: 3px 15px;
            font-size: 14px;
            cursor: pointer;
        }
    }

    .desTopClass {
        .typeName {
            font-size: 14px;
            width: 85px;
            letter-spacing: 23px;
        }

        .destoPone {
            p {
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }

            .materDetailsT {
                // background: #157efb;
                color: #157efb;
                border-radius: 5px;
                padding: 3px 15px;
                margin-bottom: 10px;
            }
        }

        .print_screen_boxP {
            display: flex;
            flex-wrap: wrap;

            p {
                cursor: pointer;
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }

            .screen_text {
                color: #157efb;
                background: #157efb;
                border-radius: 5px;
                margin-bottom: 10px;
                color: #fff;
                padding: 3px 15px;
                font-size: 14px;
                cursor: pointer;
            }
        }

        ul {
            display: flex;

            li {
                padding: 5px 12px;
                cursor: pointer;
                margin-right: 10px;

                &.active {
                    color: #fff;
                    background: #157efb;
                    border-radius: 4px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commission/commissionDialog.vue